// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fbad6a85","488":"5fd59f3f"}[chunkId] + ".chunk.js";
};